import { useEffect } from 'react';
import { DataLayerUtils } from './../DataLayerUtils';

interface EventListenerConfig {
    selector: string;
    handler: (element: Element) => () => void;
}

export const useEventListeners = (configs: EventListenerConfig[], dependencies: any[]) => {
    useEffect(() => {
        const eventClickHandlerReferences: [Element, EventListener][] = [];

        configs.forEach(({ selector, handler }) => {
            DataLayerUtils.addEventListeners(selector, handler, eventClickHandlerReferences);
        });

        return () => {
            eventClickHandlerReferences.forEach(([element, eventHandler]) => {
                element.removeEventListener('click', eventHandler);
            });
        };
    }, dependencies);
};
